/**
 * ReDelivery v1
 * El delivery mas coopado
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { OfferInputDto } from '../model/offerInputDto';
import { OfferOutputDto } from '../model/offerOutputDto';
import { OfferUpdateDto } from '../model/offerUpdateDto';
import { OfferBannerDto } from '../model/offerBannerDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class OfferService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param cdoffer 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOfferDeleteOfferDelete(cdoffer?: number, observe?: 'body', reportProgress?: boolean): Observable<boolean>;
    public apiOfferDeleteOfferDelete(cdoffer?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<boolean>>;
    public apiOfferDeleteOfferDelete(cdoffer?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<boolean>>;
    public apiOfferDeleteOfferDelete(cdoffer?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdoffer !== undefined && cdoffer !== null) {
            queryParameters = queryParameters.set('cdoffer', <any>cdoffer);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<boolean>('delete',`${this.basePath}/api/Offer/DeleteOffer`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdoffer 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOfferDisableOfferPut(cdoffer?: number, observe?: 'body', reportProgress?: boolean): Observable<OfferOutputDto>;
    public apiOfferDisableOfferPut(cdoffer?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OfferOutputDto>>;
    public apiOfferDisableOfferPut(cdoffer?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OfferOutputDto>>;
    public apiOfferDisableOfferPut(cdoffer?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdoffer !== undefined && cdoffer !== null) {
            queryParameters = queryParameters.set('cdoffer', <any>cdoffer);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<OfferOutputDto>('put',`${this.basePath}/api/Offer/DisableOffer`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOfferEditOfferPut(body?: OfferUpdateDto, observe?: 'body', reportProgress?: boolean): Observable<OfferOutputDto>;
    public apiOfferEditOfferPut(body?: OfferUpdateDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OfferOutputDto>>;
    public apiOfferEditOfferPut(body?: OfferUpdateDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OfferOutputDto>>;
    public apiOfferEditOfferPut(body?: OfferUpdateDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<OfferOutputDto>('put',`${this.basePath}/api/Offer/EditOffer`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdoffer 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOfferEnableOfferPut(cdoffer?: number, observe?: 'body', reportProgress?: boolean): Observable<OfferOutputDto>;
    public apiOfferEnableOfferPut(cdoffer?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OfferOutputDto>>;
    public apiOfferEnableOfferPut(cdoffer?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OfferOutputDto>>;
    public apiOfferEnableOfferPut(cdoffer?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdoffer !== undefined && cdoffer !== null) {
            queryParameters = queryParameters.set('cdoffer', <any>cdoffer);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<OfferOutputDto>('put',`${this.basePath}/api/Offer/EnableOffer`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOfferGetAllOffersActiveGet(observe?: 'body', reportProgress?: boolean): Observable<Array<OfferOutputDto>>;
    public apiOfferGetAllOffersActiveGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OfferOutputDto>>>;
    public apiOfferGetAllOffersActiveGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OfferOutputDto>>>;
    public apiOfferGetAllOffersActiveGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OfferOutputDto>>('get',`${this.basePath}/api/Offer/GetAllOffersActive`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOfferGetAllOffersGet(observe?: 'body', reportProgress?: boolean): Observable<Array<OfferOutputDto>>;
    public apiOfferGetAllOffersGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OfferOutputDto>>>;
    public apiOfferGetAllOffersGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OfferOutputDto>>>;
    public apiOfferGetAllOffersGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<OfferOutputDto>>('get',`${this.basePath}/api/Offer/GetAllOffers`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param cdoffer 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOfferGetOneGet(cdoffer?: number, observe?: 'body', reportProgress?: boolean): Observable<OfferOutputDto>;
    public apiOfferGetOneGet(cdoffer?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<OfferOutputDto>>;
    public apiOfferGetOneGet(cdoffer?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<OfferOutputDto>>;
    public apiOfferGetOneGet(cdoffer?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (cdoffer !== undefined && cdoffer !== null) {
            queryParameters = queryParameters.set('cdoffer', <any>cdoffer);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<OfferOutputDto>('get',`${this.basePath}/api/Offer/GetOne`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

     /**
     * 
     * 
     * @param cdStore 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
      public apiOfferGetOffersBannerGet(cdStore?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<OfferBannerDto>>;
      public apiOfferGetOffersBannerGet(cdStore?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<OfferBannerDto>>>;
      public apiOfferGetOffersBannerGet(cdStore?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<OfferBannerDto>>>;
      public apiOfferGetOffersBannerGet(cdStore?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
  
  
          let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
          if (cdStore !== undefined && cdStore !== null) {
              queryParameters = queryParameters.set('cdStore', <any>cdStore);
          }
  
          let headers = this.defaultHeaders;
  
          // authentication (Bearer) required
          if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
              headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
          }
  
          // to determine the Accept header
          let httpHeaderAccepts: string[] = [
              'text/plain',
              'application/json',
              'text/json'
          ];
          const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
          if (httpHeaderAcceptSelected != undefined) {
              headers = headers.set('Accept', httpHeaderAcceptSelected);
          }
  
          // to determine the Content-Type header
          const consumes: string[] = [
          ];
  
          return this.httpClient.request<Array<OfferBannerDto>>('get',`${this.basePath}/api/Offer/GetOffersBanner`,
              {
                  params: queryParameters,
                  withCredentials: this.configuration.withCredentials,
                  headers: headers,
                  observe: observe,
                  reportProgress: reportProgress
              }
          );
      }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiOfferPostOfferPost(body?: OfferInputDto, observe?: 'body', reportProgress?: boolean): Observable<number>;
    public apiOfferPostOfferPost(body?: OfferInputDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<number>>;
    public apiOfferPostOfferPost(body?: OfferInputDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<number>>;
    public apiOfferPostOfferPost(body?: OfferInputDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<number>('post',`${this.basePath}/api/Offer/PostOffer`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
